import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fetchWrapper from "../utils/httpClient";
import {
  API_CREATE_PRODUCTS,
  API_DELETE_PRODUCTS,
  API_GET_PRODUCTS,
} from "../utils/apis";
import { API_STATE } from "../utils/constant";

// Asynchronous thunk for fetching resources by content type
export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (language) => {
    const params = new URLSearchParams({
      region: "SG",
      language,
    });
    try {
      const response = await fetchWrapper.get(
        `${API_GET_PRODUCTS}?${params.toString()}`
      );
      return response.resdata;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const createProducts = createAsyncThunk(
  "products/createProducts",
  async (payload) => {
    try {
      const productData = {
        ...payload,
        languages: ["EN", "CN"],
        region: "SG"
      };

      const response = await fetchWrapper.post(API_CREATE_PRODUCTS, productData);
      return response;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const deleteProducts = createAsyncThunk(
  "products/deleteProducts",
  async (uuid) => {
    try {
      return await fetchWrapper.delete(`${API_DELETE_PRODUCTS}/${uuid}`);
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

// Slice
const productsSlice = createSlice({
  name: "productList",
  initialState: {
    data: null,
    status: API_STATE.IDLE,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetch products
      .addCase(fetchProducts.pending, (state) => {
        state.error = null;
        state.status = API_STATE.LOADING;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = API_STATE.SUCCEEDED;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = API_STATE.FAILED;
      });
  },
});

//Action creators are generated for each case reducer function
// export const {} = productSlice.actions;

// Export the async action so it can be dispatched from components
export default productsSlice.reducer;
